import Button from "@/shared/form/button";
import { BpmRolesListRecordFragment } from "gql/graphql";
import { useTranslations } from "use-intl";
import { Person } from "@/modules/common/entities/person";
import { BpmRoleAssignment } from "@/modules/bpm/entities/bpm-role-assignment";

export const titles = {
  person: "Person",
  department: "Department",
  role: "Role",
  bpmRolesList: "Bpm roles list",
};

export const BpmRolesListColumns = {
  PersonName: PersonCell,
  Department,
  Role,
  Mobile,
};

export function PersonCell({
  record,
  setEditId,
}: {
  record: BpmRolesListRecordFragment;
  setEditId: (id: string | null) => void;
}) {
  return (
    <Button type="link" onClick={() => setEditId(record.id)} className={"!p-0"}>
      <Person.Name data={record.person} />
    </Button>
  );
}

export function Department({ record }: { record: BpmRolesListRecordFragment }) {
  return <BpmRoleAssignment.Department data={record} />;
}

export function Role({ record }: { record: BpmRolesListRecordFragment }) {
  return <BpmRoleAssignment.Role data={record} />;
}

export function Mobile({
  record,
  setEditId,
}: {
  record: BpmRolesListRecordFragment;
  setEditId: (id: string | null) => void;
}) {
  const t = useTranslations("BpmRolesList");

  return (
    <div className={"grid gap-2"}>
      <div>
        <PersonCell record={record} setEditId={setEditId} />
      </div>

      <div>
        <span>{t(titles.department)}: </span>
        <Department record={record} />
      </div>

      <div>
        <span>{t(titles.role)}: </span>
        <Role record={record} />
      </div>
    </div>
  );
}
